<template>
	<div report :class="{ dimOpen: isDim }">
		<!-- <div class="dim"></div> -->
		<div class="top-cont">
			<div class="top-btns">
				<a @click="back" class="back">뒤로가기 </a>
				<h2><img src="@/assets/images/mypage/ico-account.png" alt=""></h2>
			</div>
		</div>

        <InfinityScroll :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle">
            <section class="report">
                <div>
                    <h2>신고내역</h2>

                    <p class="txt">건전한 커뮤니티 환경을 만들기 위해 사커하우는 회원님의 소중한 의견을 반영하여 신고를 접수하고 그에 따른 조치를 취하겠습니다. 회원님이 신고하신 내용을 확인해보세요</p>

                    <div class="tab-wrap" style="position:sticky; top:0px; padding-top:10px;background-color: white;z-index: 1;">
                        <a class="tab" @click="setFilter(null)" :class="{ on: currentFilter === null }">전체보기</a>
                        <a class="tab" @click="setFilter('post')" :class="{ on: currentFilter === 'post' }">게시물</a>
                        <a class="tab" @click="setFilter(REPORT_TYPE_IDX.PROFILE)" :class="{ on: currentFilter === REPORT_TYPE_IDX.PROFILE }">회원</a>
                    </div>

                    <ul class="list">
                        <li v-for="item in setFiltered" :key="item.id">
                            <p class="date">신고날짜 : {{ item.insert_date }}</p>
                            <p class="tit">{{ item.title }} <span v-if="parseInt(item.refer_type) === REPORT_TYPE_IDX.PROFILE">프로필 신고</span> - {{ item.is_treated === '0' ? '대기중' : '조치 완료' }}</p>
                            <a @click="popOpen(item); $Util.sendEventClick('마이_신고내역_신고게시물')">팝업열기</a>
                        </li>
                    </ul>
                </div>
            </section>
        </InfinityScroll>

		<!--피드백-->
		<CommonPopupFrame :changeHeight="95" :closeCompleteAction="close" :isOpen="isFeed">
			<div class="top-btns type2">
				<a class="close" @click="close">닫기</a>
				<h3>신고 피드백</h3>
			</div>
			<div class="content-detail">
				<div class="inner">
					<div class="top">
						<img src="@/assets/images/mypage/ico-account.png" alt="">
						<p class="tit">피드백</p>
						<p class="txt">신고가 접수됐습니다. 신고 내용 검토 후 조치 예정입니다.</p>
					</div>
					<div class="complete">
						<p class="c-tit">{{ reportDetail.title }} - {{ reportDetail.is_treated === '0' ? '대기중' : '조치 완료' }}</p>
						<p class="c-txt">게시물 내용 : "{{ reportDetail.report_contents }}"</p>
						<p class="txt">신고날짜 : {{ reportDetail.insert_date }}</p>
						<p class="txt">신고 대상 : {{ reportDetail.refer_type_name }}</p>
						<p class="txt">신고 사유 : {{ reportDetail.reason }}</p>
						<p class="txt">신고 대상 : {{ reportDetail.target_nic_name }}</p>
					</div>
				</div>
			</div>
			<div class="btns">
				<a class="btn" @click="close">확인</a>
			</div>
		</CommonPopupFrame>
	</div>
</template>
  
<script>
import CommonPopupFrame from './CommonPopupFrame';
import { REPORT_TYPE_IDX } from '../../../Constants';
import InfinityScroll from "../../common/InfinityScroll";

export default {
	name: "Report",
	components: {InfinityScroll, CommonPopupFrame },
	data() {
		return {
			list: [],
			currentFilter: null,
			isDim: false,
			isFeed: false,
			page: 1,
			REPORT_TYPE_IDX: REPORT_TYPE_IDX,
			reportDetail: {},
            isEnableNextPageHandle : true,
		}
	},
	methods: {
		setFilter: function (category) {
			this.page = 1;
			this.list = [];
			this.currentFilter = category;
			this.getReportList();
		},
		popOpen(item) {
			this.reportDetail = item

			this.isFeed = true;
			this.isDim = true;
		},
		close() {
			this.isFeed = false;
			this.isDim = false;
		},
		back() {
			this.$GlobalStore.closeLastModal()
		},
		async getReportList() {
            this.isEnableNextPageHandle = false;
			const parameters = {}
			parameters.page = this.page;
			if(this.currentFilter === 'post'){
				parameters.report_types = [REPORT_TYPE_IDX.SOCCERHOW_ANYONE, REPORT_TYPE_IDX.SOCCERHOW_COACH, REPORT_TYPE_IDX.JOIN_COMMUNITY, REPORT_TYPE_IDX.JOIN_SCHEDULE];
			}
			if(this.currentFilter === REPORT_TYPE_IDX.PROFILE) parameters.report_types = [REPORT_TYPE_IDX.PROFILE];

			const res = await this.$Axios.get('/api/report/list', { params: parameters })
            const reports = res.data.reports

            if(reports.length > 0){
                reports.forEach(item => {
                    item.insert_date = item.insert_date.split(' ')
                    item.insert_date[0] = `${item.insert_date[0].replace(/-/g, '.')} / `
                    item.insert_date[1] = item.insert_date[1].slice(0, 5)

                    item.insert_date = item.insert_date.join(' ')
                })

                this.isEnableNextPageHandle = true;
                this.list = [...this.list, ...reports];
            }

		},
        handleNextPage(){
			this.page++;
			this.getReportList();
        }
	},
	computed: {
		setFiltered() {
			let data

			if (this.currentFilter) {
				if (this.currentFilter === REPORT_TYPE_IDX.PROFILE) {
					data = this.list.filter((item) => {
						return parseInt(item.refer_type) === this.currentFilter
					})
				} else {
					data = this.list.filter((item) => {
						return parseInt(item.refer_type) !== REPORT_TYPE_IDX.PROFILE
					})
				}
			} else {
				data = this.list
			}

			return data;
		}
	},
	created() {
		this.getReportList()
	}
}
</script>
  
<style scoped>
* {
	font-family: var(--global-font-family);
	color: #101014;
}

h2,
h3,
h4,
p,
ul {
	margin: 0;
	padding: 0;
	list-style: none;
	margin-block: 0;
	margin-inline: 0;
}

a {
	display: inline-block;
	text-decoration: none;
	color: #101014;
}

h2 {
	font-size: 24px;
	font-weight: 500;
	line-height: 35px;
	padding: 18px 20px 10px 20px;
	box-sizing: border-box;
}

h3 {
	font-size: 20px;
	line-height: 29px;
	font-weight: 500;
	display: inline-block;
}

input {
	outline: none;
}

input[type=number]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

[report] {
	overflow: hidden;
}

.top-cont {
	width: 100%;
	background: #fff;
	z-index: 1;
}

.dim {
	background: rgba(0, 0, 0, 0.3);
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s;
	animation-timing-function: ease-out;
}

section {
	position: relative;
}

.top-btns {
	height: 60px;
	border-bottom: 1px solid;
	border-color: #F5F5F5;
	padding-top: 7px;
	box-sizing: border-box;
	text-align: center;
}

.top-btns h2 {
	padding: 0;
	display: inline-block;
	border-bottom: none;
}

.top-btns a.back {
	font-size: 0;
	width: 65px;
	height: 53px;
	position: absolute;
	left: 0;
	top: 7px;
}

.top-btns a.back:after {
	content: '';
	width: 25px;
	height: 29px;
	background: url("~@/assets/images/mypage/ico-back.png")0 0 no-repeat;
	background-size: contain;
	position: absolute;
	left: 20px;
	top: 12px;
}

.report h2 {
	margin-bottom: 12px;
}

.report .txt {
	font-size: 14px;
	line-height: 20px;
	color: #606060;
	margin-bottom: 30px;
	padding: 0 20px;
	box-sizing: border-box;
}

.report .tab-wrap {
	padding: 0 20px;
	box-sizing: border-box;
	border-bottom: 1px solid #F5F5F5;
	display: flex;
	gap: 8px;
	padding-bottom: 10px;
}

.report .tab-wrap .tab {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	border: 1px solid #f5f5f5;
	border-radius: 23px;
	padding: 12px 18px
}

.report .tab-wrap .tab.on {
	color: var(--color-tab-font);
	border-bottom: 1px solid;
	background-color: var(--color-tab);
}

.report .list li {
	padding: 20px;
	box-sizing: border-box;
	position: relative;
	border-bottom: 1px solid #F6F6F6;
}

.report .list li:last-child {
	border-bottom: none;
}

.report .list li .date {
	font-size: 14px;
	line-height: 20px;
	color: #606060;
	margin-bottom: 5px;
}

.report .list li .tit {
	font-size: 16px;
	line-height: 23px;
	color: #101014;
	font-weight: 500;
}

.report .list li a {
	font-size: 0;
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
}

.edit-page {
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;
	min-height: 70%;
	z-index: 10;
	background: #fff;
	transform: translateY(100%);
	transition: transform 0.5s;
	animation-timing-function: ease-out;
	border-top-left-radius: 25px;
	border-top-right-radius: 25px;
	box-sizing: border-box;
}

.edit-page .top-btns.type2 {
	height: auto;
	text-align: right;
	padding: 20px 10px 20px 20px;
	box-sizing: border-box;
	position: relative;
}

.edit-page .top-btns.type2 .close {
	font-size: 0;
	width: 45px;
	height: 45px;
	background: url("~@/assets/images/mypage/ico-x.png")0 0 no-repeat;
	background-size: contain;
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
}

.edit-page .top-btns.type2 h3 {
	text-align: center;
	display: block;
}

.edit-page .top-btns.type2 h4 {
	font-weight: 500;
	line-height: 23px;
	display: block;
	text-align: left;
	color: #606060;
	word-break: keep-all;
}

.btns {
	text-align: center;
	margin-bottom: 30px;
}

.btn {
	font-size: 20px;
	font-weight: 500;
	text-align: center;
	border: 1px solid;
	border-color: var(--color-main);
	line-height: 44px;
	padding: 0 100px;
	box-sizing: border-box;
	border-radius: 23px;
	cursor: pointer;
}

.edit-page.open {
	transform: translateY(0);
}

.dimOpen .dim {
	opacity: 0.5;
	z-index: 5;
}

.edit-page .content-detail .top {
	border-bottom: 1px solid #F5F5F5;
	box-sizing: border-box;
	padding: 30px 20px 20px;
}

.edit-page .content-detail .top img {
	margin: 0 auto 30px;
	display: block;
}

.edit-page .content-detail .top .tit {
	margin-bottom: 20px;
}

.edit-page .content-detail .inner p {
	font-size: 14px;
	line-height: 20px;
	color: #606060;
	padding-left: 10px;
	box-sizing: border-box;
	position: relative;
	margin-bottom: 10px;
}

.edit-page .content-detail .inner p:last-child {
	margin-bottom: 0;
}

.edit-page .content-detail .inner p:after {
	content: '';
	width: 3px;
	height: 3px;
	background: #606060;
	border-radius: 50%;
	position: absolute;
	left: 0;
	top: 9px;
}

.edit-page .content-detail .top .txt {
	padding-left: 0;
	color: #101014;
}

.edit-page .content-detail .top .txt:after {
	display: none;
}

.edit-page .content-detail .complete {
	padding: 30px 20px 50px;
	box-sizing: border-box;
}

.edit-page .content-detail .complete .c-tit {
	font-size: 16px;
	color: #101014;
	padding-left: 0;
	font-weight: 500;
}

.edit-page .content-detail .complete .c-tit:after {
	display: none;
}

.edit-page .content-detail .complete .c-txt {
	color: #101014;
}
</style>